import React from "react";
import "./FAQ.css";
import Swal from "sweetalert2";
import FeedbackIcon from "@material-ui/icons/Feedback";
import { Tooltip } from "@material-ui/core";
const FaqFeedback = () => {
  function feedBackFormLoader() {
    Swal.fire({
      html: '<iframe src="https://amazon.au1.qualtrics.com/jfe/form/SV_4PK1Q47hoYxGxFk" width="100%" height="500" sandbox="allow-forms allow-scripts allow-same-origin"></iframe>',
      showConfirmButton: false,
      width: "100%",
      customClass: {
        popup: 'swal-wide'
      }
    });
  }
  return (
    <Tooltip title="Feedback">
      <FeedbackIcon
        fontSize="large"
        className="Faq-Feedback-Icon"
        onClick={feedBackFormLoader}
      />
    </Tooltip>
  );
};

export default FaqFeedback;
